module.exports = __webpack_public_path__ + "img/empty.cfb49f55.svg";